import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info'; // Example icon

const RectangularChipBots = ({ icon, title, caption, key, onClick, themeMode }) => {
  return (
    <Box
    key={key}
    onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: 2,
        borderRadius: 2,

        boxShadow: 1,
        bgcolor: themeMode === 'dark'? '#414457' : 'background.paper',
        '&:hover': {
          boxShadow: 3,
        },
        minWidth:{sm:'49%', xs:'100%'},
        transition: 'box-shadow 0.3s ease-in-out',
        cursor:'pointer'
      }}
    >
      <Avatar variant='square' sx={{ bgcolor: 'primary.main', mr: 2, borderRadius:3 }}>
        {icon || <InfoIcon />}
      </Avatar>
      <Box>
        <Typography variant="subtitle2" fontWeight="bold">
         {title}
        </Typography>
        {/* <Typography variant="caption" color="text.secondary">
          {caption}
        </Typography> */}
      </Box>
    </Box>
  );
};

export default RectangularChipBots;
